import React from "react";
import { useFormContext } from "react-hook-form";

export const QuestionDescription = () => {
  const { register } = useFormContext();

  return (
    <label htmlFor="description">
      <div className="flex justify-between">
        <p className="mb-[10px] text-base text-black font-medium">Формулировка вопроса</p>
        <span className="text-red text-base font-bold">*</span>
      </div>

      <input
        {...register("DescriptionQuestion", { required: true })}
        id="DescriptionQuestion"
        type="text"
        className="w-full rounded-md shadow-custom mb-5 border-[#DFE4EA]"
        placeholder="Введите формулировку вопроса"
      />
    </label>
  );
};
